import { render, staticRenderFns } from "./ServerFilterListOptionSlot.vue?vue&type=template&id=36b62318&"
import script from "./ServerFilterListOptionSlot.vue?vue&type=script&lang=js&"
export * from "./ServerFilterListOptionSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QItemSection,QItemLabel,QIcon} from 'quasar'
component.options.components = Object.assign({QItem,QItemSection,QItemLabel,QIcon}, component.options.components || {})
